// extracted by mini-css-extract-plugin
export default {"LoadingSQLViewer":"SQLViewer_LoadingSQLViewer__KeZGo"};